/**
 * Shared logic for matching the app menu search query against tab metadata
 * (same rules as components/shared/Tabs.jsx).
 */
export function tabMatchesMenuSearch(tab, queryLower) {
  if (!queryLower) return true;
  const id = String(tab.id ?? '').toLowerCase();
  if (id.includes(queryLower)) return true;
  if (typeof tab.label === 'string' && tab.label.toLowerCase().includes(queryLower)) return true;
  if (typeof tab.filterKey === 'string' && tab.filterKey.toLowerCase().includes(queryLower)) {
    return true;
  }
  if (
    Array.isArray(tab.searchKeywords) &&
    tab.searchKeywords.some((kw) => String(kw).toLowerCase().includes(queryLower))
  ) {
    return true;
  }
  return false;
}
